import './scss/style.scss'
import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import SpinnerLoading from 'components/spinner'
import LogoutSync from 'components/LogoutSync'
import ToasterProvider from 'context/GlobalToasterContext'

// Containers
const TheLayout = React.lazy(() => import('./containers/layout/index'))

// Pages
const Login = React.lazy(() => import('./pages/login'))
const Page404 = React.lazy(() => import('./pages/Page404'))
const Page500 = React.lazy(() => import('./pages/Page500'))
const PrivateRoute = React.lazy(() => import('./components/route/PrivateRoute'))

const App = () => {
  return (
    <ToasterProvider>
      <Router>
        <LogoutSync />
        <React.Suspense
          fallback={<SpinnerLoading style={{ position: 'absolute', top: '50%', left: '50%' }} />}
        >
          <Switch>
            <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            <PrivateRoute path="/" name="Home" render={props => <TheLayout {...props} />} />
          </Switch>
        </React.Suspense>
      </Router>
    </ToasterProvider>
  )
}

export default App
